"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var theme_1 = require("./theme");
var classMap = {
  sm: 'w-6 h-6',
  base: 'w-10 h-10',
  lg: 'w-16 h-16'
};
var sizeMap = {
  sm: 12,
  base: 22,
  lg: 30
};
function ActionIcon(_a) {
  var icon = _a.icon,
    onClick = _a.onClick,
    _b = _a.size,
    size = _b === void 0 ? 'base' : _b,
    className = _a.className,
    style = _a.style;
  var text = theme_1.useTextColor(className, true);
  var sizeStr = classMap[size];
  return react_1.default.createElement("div", {
    role: onClick ? 'button' : 'div',
    className: classnames_1.default('inline-flex items-center justify-center border rounded-full cursor-pointer hover:bg-gray-200 dark-hover:bg-gray-800', sizeStr, text),
    onClick: onClick,
    style: style
  }, react_1.default.cloneElement(icon, {
    size: sizeMap[size]
  }));
}
exports.ActionIcon = ActionIcon;